
export class ScanTarget {
  public id?: number;
  public accountId?: number;
  public externalId?: string;
  public name?: string;
  public location?: string;
  public type?: string;
  public localIpAddress?: string;
  public operatingSystem?: string;
  public operatingSystemVersion?: string;
  public lastScanResultId?: number;
  public lastScanResultTimestamp?: Date;
  public companyName?: string;
  public totalCount?: string;
  public failCount?: string;
  public passCount?: string;

  constructor(obj: ScanTarget = {} as ScanTarget) {
    this.id = obj.id;
    this.accountId = obj.accountId;
    this.externalId = obj.externalId;
    this.name = obj.name;
    this.location = obj.location;
    this.type = obj.type;
    this.localIpAddress = obj.localIpAddress;
    this.operatingSystem = obj.operatingSystem;
    this.operatingSystemVersion = obj.operatingSystemVersion;
    this.lastScanResultId = obj.lastScanResultId;
    this.lastScanResultTimestamp = obj.lastScanResultTimestamp;
    this.companyName = obj.companyName;
    this.totalCount = obj.totalCount;
    this.failCount = obj.failCount;
    this.passCount = obj.passCount;
  }
}